'use client';
import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

import CustomImage from '@/app/_components/custom-image/CustomImage';
import { ImageTransformationKeys } from '@/types/files/files.types';

import Styles from './Banner.module.scss';

type Props = {
  imageKeys: ImageTransformationKeys;
  bannerImage?: string | undefined;
  heading: string;
};

const BannerSection = ({ heading, imageKeys, bannerImage }: Props) => {
  return (
    <Box className={Styles.bannerWrapper}>
      <CustomImage
        imageSrc={bannerImage}
        className={Styles.bannerImage}
        imageKeys={imageKeys}
        loading="eager"
      />

      <div className={Styles.bannerContentWrapper}>
        <div className={Styles.bannerContent}>
          <div className={Styles.headingElement}>
            <Heading
              as="h1"
              className={Styles.titleLg}
              marginBottom={{ base: 4, md: 8 }}
            >
              {heading}
            </Heading>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default BannerSection;
